export default __webpack_public_path__ + "static/logo-11-1f89ecd76cfc821ef837c0e0f80b0b35.webp";